/** Internal type. DO NOT USE DIRECTLY. */
type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
/** Internal type. DO NOT USE DIRECTLY. */
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
// @ts-ignore
import type * as Types from '../../../../../packages/graphql/index';

import { gql } from '@apollo/client';
import { ContractFragmentFragmentDoc } from './contractFragment.generated';
import { CompanyFragmentFragmentDoc } from './companyFragment.generated';
import { SocialTagsFragmentFragmentDoc } from './socialTagsFragment.generated';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type Brand_Enum =
  /** G20 */
  | 'G20'
  /** Auchan Hyper */
  | 'auchan_hyper'
  /** Auchan MyAuchan */
  | 'auchan_myauchan'
  /** Auchan Super */
  | 'auchan_super'
  /** Biocoop */
  | 'biocoop'
  /** Carrefour City */
  | 'carrefour_city'
  /** Carrefour Contact */
  | 'carrefour_contact'
  /** Carrefour Express */
  | 'carrefour_express'
  /** Carrefour Hyper */
  | 'carrefour_hyper'
  /** Carrefour Market */
  | 'carrefour_market'
  /** Coccimarket */
  | 'coccimarket'
  /** Coccimarket City */
  | 'coccimarket_city'
  /** Coccimarket Easy */
  | 'coccimarket_easy'
  /** Cora */
  | 'cora'
  /** Diago */
  | 'diago'
  /** E.Leclerc */
  | 'e_leclerc'
  /** E.Leclerc Express */
  | 'e_leclerc_express'
  /** Franprix */
  | 'franprix'
  /** Hyper U */
  | 'hyper_u'
  /** Intermarché Contact */
  | 'intermarche_contact'
  /** Intermarché Express */
  | 'intermarche_express'
  /** Intermarché Hyper */
  | 'intermarche_hyper'
  /** Intermarché Super */
  | 'intermarche_super'
  /** Monop’ */
  | 'monop'
  /** Monoprix */
  | 'monoprix'
  /** Netto */
  | 'netto'
  /** Sitis Market */
  | 'sitis_market'
  /** Spar */
  | 'spar'
  /** Super U */
  | 'super_u'
  /** U Express */
  | 'u_express'
  /** Utile */
  | 'utile';

export type Business_Profile_Enum =
  | 'BUYER'
  | 'SUPPLIER';

export type Contract_Status_Enum =
  | 'SIGNED'
  | 'UNSIGNED';

export type Minimum_Order_Value_Type_Enum =
  | 'PACKAGING'
  | 'PRICE'
  | 'WEIGHT';

export type Social_Tag_Type_Enum =
  | 'ENGAGED_STORE'
  | 'GUARANTEED_SALES'
  | 'HIDDEN_GEM'
  | 'HIGHLY_RESPONSIVE'
  | 'HIGH_MARGIN'
  | 'NEW_ARRIVAL'
  | 'POPULAR'
  | 'TREND';

export type ContractsAsBuyerQueryVariables = Exact<{
  companyId?: string | null | undefined;
  userId: string;
}>;


export type ContractsAsBuyerQuery = { contract: Array<{ id: string, reference_id: string, minimum_order_value: number | null, minimum_order_value_type: Types.Minimum_Order_Value_Type_Enum, is_trusted_supplier: boolean, order_count: number | null, supplyingCompanyId: string, buyingCompanyId: string, last_order_date: string | null, status: Types.Contract_Status_Enum, discount: number, channel_url: string | null, custom_price_list_id: string | null, sub_catalog_id: string | null, company: { is_wholesaler: boolean, id: string, business_profile: Types.Business_Profile_Enum, description: string | null, contactEmail: string, contactPhoneNumber: string, tradeName: string, brand: Types.Brand_Enum | null, addresses: Array<{ latitude: number, longitude: number }>, products: Array<{ sub_family: string }>, products_aggregate: { aggregate: { max: { sub_family: string | null } | null } | null }, social_tags: Array<{ id: string, level: number, priority: number, type: Types.Social_Tag_Type_Enum, values: { [key: string]: any } | null }>, photos: Array<{ photo: { path: string, domain: string | null } }> }, custom_price_list: { name: string, custom_price_list_packagings: Array<{ packaging_sku: number, company_id: string, discount: number }> } | null, sub_catalog: { name: string, sub_catalog_packagings: Array<{ packaging_sku: number, supplier_company_id: string }> } | null }>, all_contracts_total_price: Array<{ reference_id: string, total_price: number }> };


export const ContractsAsBuyerDocument = /*#__PURE__*/ gql`
    query contractsAsBuyer($companyId: uuid, $userId: uuid!) {
  contract(
    where: {buyingCompanyId: {_eq: $companyId}}
    order_by: {supplying_company: {tradeName: asc}}
  ) {
    ...contractFragment
    company: supplying_company {
      ...companyFragment
      is_wholesaler
      addresses {
        latitude
        longitude
      }
      products(distinct_on: [sub_family]) {
        sub_family
      }
      products_aggregate {
        aggregate {
          max {
            sub_family
          }
        }
      }
      social_tags(where: {base_unit_sku: {_is_null: true}}) {
        ...socialTagsFragment
      }
    }
  }
  all_contracts_total_price(
    args: {buying_company_id: $companyId, user_id: $userId}
  ) {
    reference_id
    total_price
  }
}
    ${ContractFragmentFragmentDoc}
${CompanyFragmentFragmentDoc}
${SocialTagsFragmentFragmentDoc}`;

/**
 * __useContractsAsBuyerQuery__
 *
 * To run a query within a React component, call `useContractsAsBuyerQuery` and pass it any options that fit your needs.
 * When your component renders, `useContractsAsBuyerQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useContractsAsBuyerQuery({
 *   variables: {
 *      companyId: // value for 'companyId'
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useContractsAsBuyerQuery(baseOptions: Apollo.QueryHookOptions<ContractsAsBuyerQuery, ContractsAsBuyerQueryVariables> & ({ variables: ContractsAsBuyerQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ContractsAsBuyerQuery, ContractsAsBuyerQueryVariables>(ContractsAsBuyerDocument, options);
      }
export function useContractsAsBuyerLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ContractsAsBuyerQuery, ContractsAsBuyerQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ContractsAsBuyerQuery, ContractsAsBuyerQueryVariables>(ContractsAsBuyerDocument, options);
        }
// @ts-ignore
export function useContractsAsBuyerSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ContractsAsBuyerQuery, ContractsAsBuyerQueryVariables>): Apollo.UseSuspenseQueryResult<ContractsAsBuyerQuery, ContractsAsBuyerQueryVariables>;
export function useContractsAsBuyerSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ContractsAsBuyerQuery, ContractsAsBuyerQueryVariables>): Apollo.UseSuspenseQueryResult<ContractsAsBuyerQuery | undefined, ContractsAsBuyerQueryVariables>;
export function useContractsAsBuyerSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ContractsAsBuyerQuery, ContractsAsBuyerQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ContractsAsBuyerQuery, ContractsAsBuyerQueryVariables>(ContractsAsBuyerDocument, options);
        }
export type ContractsAsBuyerQueryHookResult = ReturnType<typeof useContractsAsBuyerQuery>;
export type ContractsAsBuyerLazyQueryHookResult = ReturnType<typeof useContractsAsBuyerLazyQuery>;
export type ContractsAsBuyerSuspenseQueryHookResult = ReturnType<typeof useContractsAsBuyerSuspenseQuery>;
export type ContractsAsBuyerQueryResult = Apollo.QueryResult<ContractsAsBuyerQuery, ContractsAsBuyerQueryVariables>;